import { render, staticRenderFns } from "./StatsButtons.vue?vue&type=template&id=9e7f2632&"
import script from "./StatsButtons.vue?vue&type=script&lang=js&"
export * from "./StatsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports